module.exports = __webpack_public_path__ + "static/media/Ava-3293561590_3cbda89e76.1e41789a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Ava-3293561590_3cbda89e76.jpg
// module id = 24
// module chunks = 0